(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details"]) return;
  try {
    
  (() => {
    function initializeReviewPreviews() {
      document.querySelectorAll('[data-review-preview]').forEach((root) => {
        if (root.dataset.ready) return;
        root.dataset.ready = 'true';
        const body = root.querySelector('.skeiso-review-preview__body');
        const button = root.querySelector('.skeiso-review-preview__toggle');
        let expanded = false;
        const sync = () => {
          const limit = parseFloat(getComputedStyle(root).getPropertyValue('--review-preview-height'));
          const needsToggle = body.scrollHeight > limit + 4;
          button.hidden = !needsToggle && !expanded;
          root.classList.toggle('is-collapsed', needsToggle && !expanded);
          button.setAttribute('aria-expanded', String(expanded));
          button.textContent = expanded ? button.dataset.less : button.dataset.more;
        };
        button.addEventListener('click', () => {
          expanded = !expanded;
          sync();
          if (!expanded) root.scrollIntoView({block:'start', behavior:'auto'});
        });
        body.addEventListener('focusin', () => { if (!expanded) { expanded = true; sync(); } });
        body.addEventListener('click', (event) => { if (!expanded && event.target.closest('button, a, input, select, textarea, [role="button"]')) { expanded = true; sync(); } });
        const observer = new ResizeObserver(sync);
        observer.observe(body);
        const widget = body.querySelector('.jdgm-widget');
        if (widget) observer.observe(widget);
        const mutations = new MutationObserver(sync);
        mutations.observe(body, {childList:true, subtree:true});
        sync();
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeReviewPreviews, {once:true});
    else initializeReviewPreviews();
    document.addEventListener('shopify:section:load', initializeReviewPreviews);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skeiso-video-hub"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('skeiso-video-hub')){
 customElements.define('skeiso-video-hub',class extends HTMLElement{
  applyFilter(selected){let count=0;this.querySelectorAll('button[data-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.filter===selected)));this.querySelectorAll('[data-models]').forEach(card=>{const visible=selected==='all'||card.dataset.models.split('|').map(s=>s.trim()).includes(selected);if(!visible&&!card.hidden){const frame=card.querySelector('iframe');if(frame)frame.src=frame.src;}card.hidden=!visible;if(visible)count++;});const empty=this.querySelector('.svh__empty');if(empty)empty.hidden=count>0;}
  connectedCallback(){if(this._handler)return;this._handler=e=>{const button=e.target.closest('button[data-filter]');if(!button||!this.contains(button))return;this.applyFilter(button.dataset.filter);};this.addEventListener('click',this._handler);const selected=new URLSearchParams(window.location.search).get('product');if(['SKS-1','SKS-2','BJL-05A','JXS-037C','SKS-3','JXS50 + JXS50A'].includes(selected))this.applyFilter(selected);}
  disconnectedCallback(){this.removeEventListener('click',this._handler);this._handler=null;}
 });
}

  } catch(e) { console.error(e); }
})();
})();
